import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { jsx as t } from "react/jsx-runtime";
import e from "styled-components";
import { calculateRem as i } from "@vds-core/utilities";
var a = e.img.withConfig({
    displayName: "StyledImg",
    componentId: "VDS__sc-1sspnel-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  object-fit: contain;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]))),
  n = e.div.withConfig({
    displayName: "ImageWrapper",
    componentId: "VDS__sc-1sspnel-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  max-width: ", "px;\n  height: ", "px;\n  width: 100%;\n  overflow: hidden;\n  border-radius: ", ";\n  display: flex;\n"])), function (_ref) {
    var t = _ref.$maxWidth;
    return t;
  }, function (_ref2) {
    var t = _ref2.$maxHeight;
    return t;
  }, i(4)),
  r = function r(e) {
    var i = e.size,
      r = e.src,
      o = e.alt,
      s = e.ariaLabel;
    return t(n, {
      $maxWidth: i,
      $maxHeight: i,
      children: t(a, {
        src: r,
        alt: o,
        "aria-label": s
      })
    });
  };
r.defaultProps = {
  size: "72"
}, r.displayName = "ListGroupItemImage";
export { r as default };